export const fruitData = {
    gameLoaded: false,
    betAmount: 0.5,
    fly: false,
    jwtToken: null,
    userId: 0,
    gameLanguage: null,
    balance: 0,
    showAutoAndTurbo: true,
    betSettings: [1, 2, 5],
    betMultiplier: 0,
    isNewUser: false,
    roundSettings: [4, 5, 6, 7],
    isJackpotActive: false,
    betPointer: 0,
    roundPointer: 0,
    totalRounds: 4,
    vibration: true,
    placeBet: false,
    play: false,
    turboPlay: false,
    roundValues: [],
    fruitName: null,
    previousFruit: [],
    currentRound: 0,
    autoPlay: false,
    num: -1,
    timer: false,
    bucketPointer: 0,
    sounds: true,
    tierOneHit: true,
    tierTwoHit: true,
    tierOneCeil: 0,
    tierPointer: 0,
    bomb:0,
    winType: null,
    showWin: false,
    isJackpotActive: false,
    winName: "",
    prizeUpgrade: false,
    jackpotMinorWin: false,
    jackpotMajorWin: false,
    jackpotGrandWin: false,
    showAmount: false,
    baseUrl: process.env.REACT_APP_BACKEND_URL_HTTP
}

let _isDemo = false;

const fruitDemo = {
    get isDemo() {
        return _isDemo;
    },
    set isDemo(value) {
        _isDemo = Boolean(value);
    }
};

export default fruitDemo;